import { useEffect, useState } from 'react';

const KEY = 'uinoter.activeOrgId';

export function getActiveOrgId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveOrgId(orgId: string | null): void {
  try {
    if (orgId == null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, orgId);
  } catch {
    // localStorage may be blocked in some contexts; non-fatal
  }
  // Cross-component sync within this tab.
  window.dispatchEvent(new CustomEvent('uinoter:org-changed', { detail: orgId }));
}

export function useActiveOrgId(): [string | null, (id: string | null) => void] {
  const [orgId, setOrgIdState] = useState<string | null>(() => getActiveOrgId());

  useEffect(() => {
    const onCustom = (e: Event) => {
      const id = (e as CustomEvent<string | null>).detail;
      setOrgIdState(id);
    };
    const onStorage = (e: StorageEvent) => {
      if (e.key === KEY) setOrgIdState(e.newValue);
    };
    window.addEventListener('uinoter:org-changed', onCustom);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('uinoter:org-changed', onCustom);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return [orgId, setActiveOrgId];
}
